var _require = require('../utils/utils'),
    isPlainObject = _require.isPlainObject;

var types = ['item', 'property', 'lexeme', 'form', 'sense'];

module.exports = function (buildUrl) {
  return function (search, language, limit, format, uselang) {
    // Using the variable 'offset' instead of 'continue' as the later is a reserved word
    var type, offset; // polymorphism: arguments can be passed as an object keys

    if (isPlainObject(search)) {
      // Not using destructuring assigment there as it messes with both babel and standard
      var params = search;
      search = params.search;
      language = params.language;
      limit = params.limit;
      offset = params["continue"];
      format = params.format;
      uselang = params.uselang;
      type = params.type;
    }

    if (!(search && search.length > 0)) throw new Error("search can't be empty");
    language = language || 'en';
    uselang = uselang || language;
    limit = limit || '20';
    format = format || 'json';
    type = type || 'item';
    offset = offset || '0';
    if (!types.includes(type)) throw new Error("invalid type: ".concat(type));
    return buildUrl({
      action: 'wbsearchentities',
      search: search,
      language: language,
      limit: limit,
      "continue": offset,
      format: format,
      uselang: uselang,
      type: type
    });
  };
};